import React from 'react';
import { CircularProgress, Stack } from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';
import { useOcrInputStore } from '../store/ocrInputStore';
import { useSaveData } from '../hooks/useSaveData';
import { PanelHeader } from './PanelHeader';
import Button from '../../../core-components/theme/components/Button/Button';
import { DateTimePicker } from '../../../core-components/theme/components/DateTimePicker';

export const RightPanelHeader: React.FC = () => {
  const { selectedDateTime, setSelectedDateTime } = useOcrInputStore();
  const { saveData, isSaving } = useSaveData();

  const title = "Extracted Data";
  const isSaveDisabled = isSaving || !selectedDateTime;

  return (
    <PanelHeader title={title}>
      <Stack direction="row" spacing={1} alignItems="center">
        <DateTimePicker
          label="Date & Time"
          required
          value={selectedDateTime}
          onChange={setSelectedDateTime}
          size="small"
          sx={{
            minWidth: '220px',
            maxWidth: '250px',
          }}
          maxDateAndTime={new Date()}
        />
        <Button
          variant="contained"
          size="medium"
          startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
          onClick={() => saveData()}
          disabled={isSaveDisabled}
        >
          {isSaving ? 'Saving...' : 'Save'}
        </Button>
      </Stack>
    </PanelHeader>
  );
};